import { api } from "./api/client.js";

// Port of store/actions/asset_config.js + the all_assets / fiat_assets reducers, which were two
// views of one GET /ui/assets/config response ({ items: [{ code, name, assetType }] }).
//
// React fetched it once per active client in layout.jsx and every screen read it out of redux;
// here it is one module-level store that the first screen to need it loads, so the ledger's
// currency filter and the balances screen's fiat/coin split share a single request.

export const assets = $state({ loading: false, loaded: false, items: [], error: null });

let inFlight = null;

// All configured assets, as `{ code, name, assetType }` with assetType upper-cased ("FIAT"/"COIN")
// — React's all_assets reducer normalised the case, fiat_assets did not, and comparing against two
// different casings of the same field was a standing trap.
export const assetCodes = () => assets.items.map((asset) => asset.code);

export const fiatAssetCodes = () =>
  assets.items.filter((asset) => asset.assetType === "FIAT").map((asset) => asset.code);

export function loadAssets() {
  if (assets.loaded || inFlight) return inFlight ?? Promise.resolve();
  assets.loading = true;
  inFlight = api
    .get("/ui/assets/config")
    .then((data) => {
      assets.items = (data?.items ?? []).map((asset) => ({
        code: asset.code,
        name: asset.name,
        assetType: String(asset.assetType ?? "").toUpperCase(),
      }));
      assets.error = null;
      assets.loaded = true;
    })
    .catch((error) => {
      // Leave `loaded` false so a later screen retries rather than rendering an empty asset list
      // forever (React's spinner just hung in this case).
      assets.items = [];
      assets.error = error;
    })
    .finally(() => {
      assets.loading = false;
      inFlight = null;
    });
  return inFlight;
}
